import {
  FieldFunctionOptions,
  FieldPolicy,
  Reference,
  TypePolicies,
} from '@apollo/client'

import {
  ChannelParticipantListQuery,
  ChannelParticipantListQueryVariables,
} from 'GraphQL/Chat/TypedDocuments'

// TODO: remove TypeScript and ESLint disabling comments when in use

type ConcreteFieldPolicy<
  TResult,
  // @ts-ignore
  TArgs extends Record<string, any>,
> = FieldPolicy<TResult, TResult, TResult, FieldFunctionOptions<TArgs>>

type ReferenceCursorList<T extends { rows: any[] }> = Omit<T, 'rows'> & {
  rows: Reference[]
}

function mergeCursorList(
  existing: ReferenceCursorList<any> | undefined,
  incoming: ReferenceCursorList<any>,
  { args }: FieldFunctionOptions,
) {
  const existingRows = existing?.rows ?? []
  // eslint-disable-next-line no-underscore-dangle
  const existingRowsSet = new Set(existingRows.map(row => row.__ref))
  const incomingRows = incoming.rows.filter(
    incomingRow =>
      // eslint-disable-next-line no-underscore-dangle
      !existingRowsSet.has(incomingRow.__ref),
  )

  return {
    cursor: incoming.cursor,
    totalCount: incoming.totalCount,
    rows: args?.cursor
      ? existingRows.concat(incomingRows)
      : incomingRows.concat(existingRows),
  }
}

export default {
  Query: {
    fields: {
      channelParticipantList: {
        keyArgs: ['channelId', 'role', 'userIds'],
        merge: mergeCursorList,
        read: existing => existing,
      } as ConcreteFieldPolicy<
        ReferenceCursorList<
          ChannelParticipantListQuery['channelParticipantList']
        >,
        ChannelParticipantListQueryVariables
      >,
    },
  },
} as TypePolicies
